import { intervalsOverlap } from "geom/aabb2";
import { DIST_EPSILON } from "geom/core";

export function cutGapsIntoInterval(intervalStart: number, intervalEnd: number, gapIntervals: number[]): number[] {
  const resIntervals: number[] = [];

  let curStart = intervalStart;
  const curEnd = intervalEnd;

  for (let i = 0, l = gapIntervals.length; i < l; i += 2) {
    const gapStart = gapIntervals[i];
    const gapEnd = gapIntervals[i + 1];
    if (!(gapStart <= gapEnd)) {
      console.assert(false, "gap interval not sorted start to end");
    }

    if (!intervalsOverlap(intervalStart, intervalEnd, gapStart, gapEnd)) {
      continue;
    }
    if (gapStart <= curStart + DIST_EPSILON) {
      if (gapEnd >= curEnd) {
        return resIntervals;
      }
      curStart = gapEnd;
    } else if (gapStart > curStart + DIST_EPSILON) {
      resIntervals.push(curStart);
      resIntervals.push(gapStart);
      if (gapEnd >= curEnd) {
        return resIntervals;
      } else {
        curStart = gapEnd;
      }
    }
  }

  resIntervals.push(curStart);
  resIntervals.push(curEnd);

  return resIntervals;
}

export function cutGapsIntoIntervalStartingAtZero(length: number, gapIntervals: number[]): number[] {
  return cutGapsIntoInterval(0, length, gapIntervals);
}
